import { useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import {
  loadPatientNotes,
  toggleSubmitting,
} from "app/store/transmission/slice/transmissionSlice";

import { useUpdatePatientNotesMutation } from "app/store/transmission/api/transmissionNotesApi";
import { showErrorToast, showSuccessToast } from "utils/toast";

const usePatientNotes = (data) => {
  const theme = useTheme();
  const {
    reportId,
    patientNoteList,
    isEditPatientNote,
    currentPatientNote,
    patientNotesFocused,
    patientNotesExpanded,
    patientNotesSubmitting,
  } = useSelector((state) => state.transmission);
  const dispatch = useDispatch();

  const [updatePatientNotes] = useUpdatePatientNotesMutation();

  const handleNote = async (isDelete, note, index) => {
    try {
      dispatch(toggleSubmitting({ type: "patientNotes", value: true }));

      let noteList = [...patientNoteList];

      if (isDelete) {
        noteList = noteList.filter(
          (data, noteIndex) => data?.note !== note && noteIndex !== index
        );
      } else {
        const { note: currentNote, index: noteIndex } = currentPatientNote;

        if (noteIndex >= 0 && isEditPatientNote) {
          noteList[noteIndex] = currentNote;
        } else {
          noteList.unshift(currentNote);
        }
      }

      const result = await updatePatientNotes({
        serialNumber: data?.patient_serial_num,
        noteList: noteList,
        reportId,
      }).unwrap();

      if (result?.data) {
        dispatch(loadPatientNotes(noteList));
        showSuccessToast("Patient notes updated successfully.");
      }
    } catch (err) {
      showErrorToast(err?.message || err?.data?.message);
    } finally {
      dispatch(toggleSubmitting({ type: "patientNotes", value: false }));
    }
  };

  return {
    theme,
    dispatch,
    patientNoteList,
    patientNotesExpanded,
    currentPatientNote,
    patientNotesSubmitting,
    patientNotesFocused,
    handleNote,
  };
};

export default usePatientNotes;
